import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Notification from '@zg-rentals/multibrand-ui/lib/Notification';
import appLogger from 'app/shared/loggers/appLogger';
import { UserSelectors } from 'app/shared/selectors';

export class ErrorBoundary extends Component {
    state = { hasError: false };

    componentDidCatch(error) {
        const { user } = this.props;

        this.setState({ hasError: true });

        // You can also log the error to an error reporting service:
        appLogger.logError({
            user,
            context: 'ErrorBoundary',
            message: error.message,
        });
    }

    render() {
        const { children, errorView } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return errorView;
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    errorView: PropTypes.node,
};

ErrorBoundary.defaultProps = {
    errorView: (
        <Notification type="error" onClose={() => window.location.reload()}>
            Oops - something went wrong, please refresh the page and try again!
        </Notification>
    ),
};

function mapState(state) {
    return {
        user: UserSelectors.makeUser(state),
    };
}

export const withErrorBoundary = WrappedComponent => props => (
    <ErrorBoundary errorView={props.errorView}>
        <WrappedComponent {...props} />
    </ErrorBoundary>
);

export default connect(mapState)(ErrorBoundary);
